import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { settleCreditNote } from './api';

export function useSettleCreditNote(billId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ creditNoteId, refundMode }: { creditNoteId: number; refundMode?: string }) =>
      settleCreditNote(creditNoteId, refundMode),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.billing.creditNotes(billId) });
      queryClient.invalidateQueries({ queryKey: keys.billing.creditNoteList() });
    },
  });
}
